import kelimutu1 from '../Kelimutu/Kelimutu (1).webp'
import kelimutu2 from '../Kelimutu/Kelimutu (2).webp'
import kelimutu3 from '../Kelimutu/Kelimutu (3).webp'
import kelimutu4 from '../Kelimutu/Kelimutu (4).webp'
import kelimutu5 from '../Kelimutu/Kelimutu (5).webp'
import kelimutu6 from '../Kelimutu/Kelimutu (6).webp'
import kelimutu7 from '../Kelimutu/Kelimutu (7).webp'
import kelimutu8 from '../Kelimutu/Kelimutu (8).webp'
import kelimutu9 from '../Kelimutu/Kelimutu (9).webp'
import kelimutu10 from '../Kelimutu/Kelimutu (10).webp'
import kelimutu11 from '../Kelimutu/Kelimutu (11).webp'
import kelimutu12 from '../Kelimutu/Kelimutu (12).webp'
import kelimutu13 from '../Kelimutu/Kelimutu (13).webp'
import kelimutu14 from '../Kelimutu/Kelimutu (14).webp'
import kelimutu15 from '../Kelimutu/Kelimutu (15).webp'
import kelimutu16 from '../Kelimutu/Kelimutu (16).webp'
import kelimutu17 from '../Kelimutu/Kelimutu (17).webp'

const kelimutuimages =[
kelimutu1,kelimutu2,kelimutu3,kelimutu4,kelimutu5,kelimutu6,kelimutu7,kelimutu8,kelimutu9,kelimutu10,kelimutu11,kelimutu12,kelimutu13,kelimutu14,kelimutu13,kelimutu14,kelimutu15,kelimutu16,kelimutu17
]

export default kelimutuimages;